import { useQueryClient } from 'react-query';

const useSelectAll = (queryKey) => {
  const queryClient = useQueryClient();

  const mutate = ({ selected }) => {
    const previousData = queryClient.getQueryData(queryKey);

    return queryClient.setQueryData(queryKey, {
      ...previousData,
      quote_lines: previousData.quote_lines?.map((item) => ({
        ...item,
        is_selected: selected,
        options: item.options.map((option) => ({
          ...option,
          is_selected: false,
        })),
        variants: item.variants.map((variant) => ({
          ...variant,
          is_selected: false,
        })),
      })),
    });
  };
  return {
    mutate,
  };
};

export default useSelectAll;
